import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@c2fo/liquidity';
import useTakerMarkets from '@/enterprise/data/useTakerMarkets';
import getTakerMarketDivisionTitle from '@/utils/getTakerMarketDivisionTitle';
import getTakerMarketName from '@/utils/getTakerMarketName';
import { useLocaleFormat } from '@/utils/useLocaleFormat';
import { useOfferBuilderContext } from '../OfferBuilderContext';

const ErrorDetails = () => {
  const { t } = useTranslation();
  const {
    state: { selected, submissionErrors },
  } = useOfferBuilderContext();
  const { asNumber } = useLocaleFormat();
  const { data: takerMarkets } = useTakerMarkets();
  const [showErrorDetails, setShowErrorDetails] = useState(false);

  const errors = submissionErrors ?? [];

  if (errors.length === 0) {
    return null;
  }

  const takerMarketsWithErrors = takerMarkets?.filter((takerMarket) => {
    return errors.some((error) => {
      return (
        error.payload?.marketUuid === takerMarket.marketUuid &&
        error.payload?.supplierDivisionUuid === takerMarket.takerDivisionUuid
      );
    });
  });

  return (
    <div>
      <div className="mb-2 text-lg font-medium">{t('offerConfirmation.offerStatus')}</div>
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <div>
          <Alert
            action={{
              text: showErrorDetails ? t('core.hideDetails') : t('core.viewDetails'),
              onClick: showErrorDetails ? () => setShowErrorDetails(false) : () => setShowErrorDetails(true),
            }}
            description={t('offerConfirmation.submitErrorDescription', {
              errorCount: asNumber({ value: errors.length }),
              totalErrorCount: asNumber({ value: selected.length }),
            })}
            full
            title={t('offerConfirmation.submitError')}
            type="error"
            variant="outlined"
          />
        </div>
        {showErrorDetails && (
          <div className="mt-4">
            <div className="rounded-lg border border-stroke bg-white">
              <div className="flex max-h-80 w-full flex-col overflow-y-auto">
                {takerMarketsWithErrors?.map((takerMarket) => {
                  return (
                    <div key={takerMarket.id} className="border-b-[0.5px] border-stroke p-4 last:border-b-0">
                      <div className="text-left text-sm">
                        <div>{takerMarket.makerOrganizationName}</div>
                        <div className="font-bold">{getTakerMarketName(takerMarket)}</div>
                        <div>
                          {`${getTakerMarketDivisionTitle(takerMarket)?.title || getTakerMarketName(takerMarket)} | ${
                            takerMarket.currency
                          }`}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorDetails;
